/* global $:false */

export default class CommonLotShowSocial {
  static init () {
    Array.from($('.js-common-lot-show-social')).map((el) =>
      new CommonLotShowSocial(el))
  }

  constructor (el) {
    this.el = $(el)
    this.findElements()
    this.setupBindings()
  }

  findElements () {
    this.foldout = $('.js-common-lot-show-social__icon')
  }

  setupBindings () {
    this.el.click(event => {
      event.preventDefault()
      this.el.hide()
      this.foldout.show()
    })
  }
}
